import Reveal from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Capture",
    body: "A tasked constellation and public missions stream optical, radar and thermal imagery over India every orbit. day, night, and through cloud.",
    image: "https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?auto=format&fit=crop&w=1200&q=80",
  },
  {
    n: "02",
    title: "Model",
    body: "Our AI pipeline calibrates, aligns and interprets each frame. detecting vessels, classifying crops, and measuring change against a temporal baseline.",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1200&q=80",
  },
  {
    n: "03",
    title: "Decide",
    body: "Signals become alerts, dashboards and API feeds. delivered to coast guards, agencies and agri-enterprises in time to act.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80",
  },
];

export default function Manifesto() {
  return (
    <section id="process" className="relative bg-arjuna-ink py-24 sm:py-32" data-testid="manifesto">
      <div className="container-x">
        <Reveal>
          <p className="overline">05. How it works</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 max-w-2xl font-heading text-3xl font-medium tracking-tight text-white sm:text-4xl lg:text-5xl">
            From orbit to decision, in three moves.
          </h2>
        </Reveal>

        <div className="mt-16 space-y-6">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.1}>
              <div className="group grid grid-cols-1 items-stretch gap-px overflow-hidden rounded-2xl border border-white/10 md:grid-cols-12">
                <div className="flex flex-col justify-between bg-arjuna-surface/50 p-8 md:col-span-7 lg:p-10">
                  <span className="font-mono text-6xl font-semibold text-white/10 transition-colors duration-500 group-hover:text-arjuna-teal/40 lg:text-7xl">
                    {c.n}
                  </span>
                  <div className="mt-8">
                    <h3 className="font-heading text-2xl text-white lg:text-3xl">{c.title}</h3>
                    <p className="mt-4 max-w-lg text-base leading-relaxed text-slate-400">{c.body}</p>
                  </div>
                </div>
                <div className="relative min-h-[220px] overflow-hidden md:col-span-5">
                  <div className="absolute inset-0 z-10 bg-arjuna-ink/40" />
                  <img
                    src={c.image}
                    alt={c.title}
                    className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
                  />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
